import React, { Component } from 'react';
import './Footer.css'

class Footer extends Component {
    render() {
        return (
            <div className="mt-5">
              <div className="footer row p-4 m-0">
                  <div className="col-lg-3 mb-4 d-flex flex-column">
                    <h5 className="my-2">Products</h5>
                    <a className="my-1" href="#">TVs</a>
                    <a className="my-1" href="#">Laptops</a>
                    <a className="my-1" href="#">Tablets</a>
                    <a className="my-1" href="#">Phones</a>
                    <a className="my-1" href="#">Consoles</a>
                  </div>
                  <div className="col-lg-3 mb-4 contact d-flex flex-column">
                    <h5 className="my-2">Location</h5>
                    <a className="my-1" href="#"> Long Island,NY</a>
                    <a className="my-1" href="#"> Westchester,NY</a>
                    <a className="my-1" href="#"> Paramus,NJ</a>
                    <a className="my-1" href="#"> Greenwich, CT</a>
                  </div>
                  <div className="col-lg-3 mb-4 contact d-flex flex-column">
                    <h5 className="my-2">Support</h5>
                    <a className="my-1" href="#">Contact Us</a>
                    <a className="my-1" href="#">Track Order</a>
                    <a className="my-1" href="#">Exchange</a>
                    <a className="my-1" href="#">Return Policy</a>
                  </div>
                  <div className="col-lg-3 follow mx-auto mb-4 follow d-flex flex-column">
                    <h5 className="my-2">follow us</h5>
                    <div className="social d-flex flex-column">
                        <a className="mx-auto my-2" href="https://facebook.com/wapplonyc"><i class="fab fa-facebook-f"></i></a>
                        <a className="mx-auto my-2" href="https://instagram.com/wapplonyc"><i className="fab fa-instagram"></i></a>
                        <a className="mx-auto my-2" href="https://instagram.com/wapplonyc"><i className="fab fa-twitter"></i></a>
                    </div>
                  </div>
                  <p className="copywrite mb-0 mt-5">&copy; 2020 ElectroCenter. All rights reserved.</p>
              </div>
            </div>
        );
    }
}

export default Footer;
